import { useState } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import {
  browserStorage,
  readSavedRunHistoryFilter,
  resolveRunHistoryFilter,
  runHistorySearch,
  saveRunHistoryFilter,
  type RunHistoryFilter,
} from './agentRunHistoryFilter';

/**
 * The History filter for the agent page, kept in the URL (`?skipped=…`) so
 * links reproduce the view and Back undoes a change. With no param, the
 * viewer's last choice on this browser applies.
 */
export function useRunHistoryFilter(): [
  RunHistoryFilter,
  (next: RunHistoryFilter) => void,
] {
  const search = useSearch({ from: '/authenticated/agent-pages/$agentPageId' });
  const navigate = useNavigate({ from: '/agent-pages/$agentPageId' });
  // Read once: a later write comes from this hook, which also moves the URL.
  const [saved] = useState(() => readSavedRunHistoryFilter(browserStorage()));

  // No useCallback: React Compiler memoizes this for us.
  const setFilter = (next: RunHistoryFilter) => {
    saveRunHistoryFilter(browserStorage(), next);
    void navigate({
      search: (previous) => ({ ...previous, ...runHistorySearch(next) }),
    });
  };

  return [resolveRunHistoryFilter(search, saved), setFilter];
}
